import {createListFromObject, getTextByValue} from "../../../../Utilities/Types/listUtilities";

export const OWN_QUEUE_STATUS = {
    Pending: 1,
    InReview: 2,
}

export const OWN_QUEUE_STATUS_LIST = createListFromObject(OWN_QUEUE_STATUS);


export const getOwnQueueStatusTextByValue = (value: string | number = "") => getTextByValue(OWN_QUEUE_STATUS_LIST, value);
